import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { ConnectivityContext, ConnectivityProvider } from '@/v2/state/providers';
import { StateContext } from '@/v2/state/store';
import query from '@/v2/state/query';
import ScenesHandler from '@/v2/components/application/ScenesHandler';
import Scenes from './__scenes__';
import './Connectivity.scss';

const onReady = () => {};

const ConnectivityComponent = ({ scenes }) => {
    const store = useContext(StateContext);
    const history = useHistory();

    useEffect(() => {
        const { dispatch } = store;
        dispatch({ type: 'ROUTE_LOAD' });
    }, []);

    const onFinished = () => {
        history.push('scenes.html#connectivity');
    };

    return (
        <div className="Connectivity">
            {scenes && (
                <ScenesHandler onReady={onReady} onFinished={onFinished} momentName="smartly">
                    <Scenes.Overview data={scenes[0]} path="overview" secondaryType="app" />
                    <Scenes.Trip data={scenes[1]} path="trip" />
                    <Scenes.Route data={scenes[2]} path="route" />
                    <Scenes.Charge data={scenes[3]} path="charge" />
                    <Scenes.Overview data={scenes[0]} type="home" path="overview-home" />
                    <Scenes.VoiceAssistant data={scenes[4]} path="voiceassistant" />
                    <Scenes.Defrost data={scenes[5]} path="defrost" />
                    <Scenes.Overview data={scenes[0]} type="incar" path="overview-incar" />
                    <Scenes.Inside data={scenes[6]} path="inside" />
                </ScenesHandler>
            )}
        </div>
    );
};

const ConnectivityRenderer = () => {
    const [data, setter] = useContext(ConnectivityContext);
    query(window.HELIOS.selectors.smartly, setter); // TODO: update key once corresponding AEM rename is done
    return <ConnectivityComponent scenes={data.scenes} />;
};

const Connectivity = () => (
    <ConnectivityProvider>
        <ConnectivityRenderer />
    </ConnectivityProvider>
);

export default Connectivity;
